import React, { useState } from 'react';
import api from './api';
import AuthBrand from './AuthBrand';
import { useToast } from './Toast';
import './Login.css';

function Login({ onSwitchToRegister, onSwitchToResetPassword, onLoginSuccess }) {
  const { addToast } = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await api.post('/api/login', { email, password });
      const data = response.data;
      addToast(data.message, 'success');
      document.cookie = `token=${data.token}; path=/; max-age=86400`;
      onLoginSuccess();
    } catch (error) {
      addToast(error.response?.data?.error || '登录失败，请稍后重试！', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <AuthBrand />
        <h2 className="login-title">用户登录</h2>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email" className="form-label">邮箱</label>
            <input
              type="email"
              id="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入邮箱"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password" className="form-label">密码</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="password"
                id="password"
                className="form-input"
                style={{ flex: 1, marginRight: '10px' }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="请输入密码"
                required
              />
              <button
                type="button"
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#667eea',
                  cursor: 'pointer',
                  fontSize: '14px',
                  padding: '0',
                  textDecoration: 'underline',
                  whiteSpace: 'nowrap'
                }}
                onClick={onSwitchToResetPassword}
              >
                忘记密码？
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="login-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? '登录中...' : '登录'}
          </button>
        </form>
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <span style={{ fontSize: '14px', color: '#666' }}>还没有账号？</span>
          <button
            style={{
              background: 'none',
              border: 'none',
              color: '#667eea',
              cursor: 'pointer',
              fontSize: '14px',
              padding: '0',
              textDecoration: 'underline',
              marginLeft: '5px'
            }}
            onClick={onSwitchToRegister}
          >
            立即注册
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
